import { HStack, Text, VStack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { ButtonLink, Card } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import type { ProjectModel } from "../models";
import { ProgressBar } from "../ProgressBar";
import { CardHeader } from "./CardHeader";
import { NoBudgetItems } from "./NoBudgetItems";

interface ExpenseStatsCardProps {
  project: ProjectModel;
}

const ExpenseStatsCard = ({ project }: ExpenseStatsCardProps) => {
  const allExpensesClosed = project.expensesStructured.every(
    ({ budgetItems }) => {
      return budgetItems.every(({ completed_at }) => !!completed_at);
    },
  );
  const actualProfit = project.expensesStructured.reduce(
    (prev, { budgetItems }) => {
      return (
        prev +
        budgetItems.reduce(
          (biPrev, { stats }) => biPrev + stats.actual_profit,
          0,
        )
      );
    },
    0,
  );

  return (
    <Card p="6" h="full">
      <VStack w="full" justify="space-between" h="full" align="stretch">
        <CardHeader title={t`Expenses`} mb="0">
          {!project.isTimeAndMaterials && (
            <>
              <Text fontSize="md">{t`Budget`}:</Text>
              <Text className="font-semibold" fontSize="md">
                {currency.formatByWorkspace(
                  project.stats.expenses.total_budget,
                )}
              </Text>
            </>
          )}
        </CardHeader>

        {!project.isTemplate &&
          (project.hasAnyExpenseItem ? (
            <>
              <ProgressBar.Expenses
                stats={project.stats.expenses}
                showFinalCommission={allExpensesClosed}
                showActualProfit={!allExpensesClosed}
                actualProfit={actualProfit}
                isTimeAndMaterials={project.isTimeAndMaterials}
              />
              <HStack justify="end" w="full" mt="2">
                <ButtonLink
                  variant="link"
                  size="sm"
                  leftIcon={<Icon name="plus" />}
                  href={{
                    pathname: "/expenses/create",
                    query: {
                      brandId: project.brand.id,
                      projectId: project.id,
                    },
                  }}
                >
                  <Trans>Add expense</Trans>
                </ButtonLink>
              </HStack>
              {project.isTimeAndMaterials &&
                project.stats.expenses.real_expenses === 0 && (
                  <Text mt="2">
                    <Trans>No expenses received yet</Trans>
                  </Text>
                )}
            </>
          ) : (
            <NoBudgetItems />
          ))}
      </VStack>
    </Card>
  );
};

export default observer(ExpenseStatsCard);
